import React from 'react';
import {connect} from 'react-redux';
import {authenticationService, mainService, userService} from '../../../jwt/_services';
import {history, utilHelper} from '../../../jwt/_helpers';
import {
    Collapse,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar,
    NavbarBrand,
    NavItem,
    NavLink,
    UncontrolledDropdown
} from 'reactstrap';
/*--------------------------------------------------------------------------------*/
/* Import images which are need for the HEADER                                    */
/*--------------------------------------------------------------------------------*/
import logolighticon from '../../../assets/images/logo/png/symbol-w.png';
import logolighttext from '../../../assets/images/logo/png/logotype-w.png';
import profilePhotoWhite from "../../../assets/images/icon/Icon-userWhite.svg";
import profilePhotoBlue from "../../../assets/images/icon/Icon-user.svg";
import {employeeService} from "../../../jwt/_services/hr/employeeService";
import {UserPasswordModal} from "../../../views/security/user/_passwordModal";
import {toDoTaskService} from "../../../jwt/_services/profile/toDoTaskService";
import {showLoader} from "../../../components/loader/loader";
import developicon from "../../../assets/images/develop.png";

const mapStateToProps = state => ({
    ...state
});

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.showMobilemenu = this.showMobilemenu.bind(this);
        this.sidebarHandler = this.sidebarHandler.bind(this);
        this.state = {
            currentEmployee: null,
            notifications: [],
            isOpen: false,
            loading: false,
            isTodoTask: false,
            redirect: false
        };
        this.childRef = React.createRef();
        this.toggleMenu = this.toggleMenu.bind(this);
        this.isNotification = this.isNotification.bind(this);
        this.goToMyNotifications = this.goToMyNotifications.bind(this);
        this.goToNotification = this.goToNotification.bind(this);
    }

    componentDidMount() {
        let user = ( localStorage.getItem('currentUser') !== '' ? JSON.parse(localStorage.getItem('currentUser')) : null);
        const data = {
            name: '',
            lastName: '',
            number: '',
            user: user
        };

        userService.getCurrentUserInfo()
            .then( result => {
                try {
                    localStorage.setItem('userData', JSON.stringify(result || data));
                } catch (e) {
                    console.log(e);
                }

                this.setState({currentUser: result || data})

            })
            .catch(console.log)

        // mainService.getAllMyToDoTask().then(result => {
        //     if (result !== undefined){
        //         this.setState({notifications: result});
        //     }
        // }).catch(_ => {});
    }



    /*--------------------------------------------------------------------------------*/
    /*To open Search Bar                                                              */

    /*--------------------------------------------------------------------------------*/
    toggleMenu() {
        document.getElementById('search').classList.toggle('show-search');
    }

    showModal = () => {
        this.childRef.current.showModal();
    }

    /*--------------------------------------------------------------------------------*/
    /*To open NAVBAR in MOBILE VIEW                                                   */

    /*--------------------------------------------------------------------------------*/
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    isNotification() {
        if (window.location.pathname === "/main/profile/todotask"){
            this.setState({isTodoTask: true});
        }
    }


    /*--------------------------------------------------------------------------------*/
    /*To open SIDEBAR-MENU in MOBILE VIEW                                             */

    /*--------------------------------------------------------------------------------*/
    showMobilemenu() {
        document.getElementById('main-wrapper').classList.toggle('show-sidebar');
    }

    sidebarHandler = () => {
        let element = document.getElementById('main-wrapper');
        switch (this.props.settings.activeSidebarType) {
            case 'full':
            case 'iconbar':
                element.classList.toggle('mini-sidebar');
                if (element.classList.contains('mini-sidebar')) {
                    element.setAttribute('data-sidebartype', 'mini-sidebar');
                } else {
                    element.setAttribute(
                        'data-sidebartype',
                        this.props.settings.activeSidebarType
                    );
                }
                break;

            case 'overlay':
            case 'mini-sidebar':
                element.classList.toggle('full');
                if (element.classList.contains('full')) {
                    element.setAttribute('data-sidebartype', 'full');
                } else {
                    element.setAttribute(
                        'data-sidebartype',
                        this.props.settings.activeSidebarType
                    );
                }
                break;

            default:
        }
        let showHide = this.state.isOpen ? 'show' : 'hide';
        document.getElementById("module-text").classList.toggle(showHide);
    };

    handleLogout = async () => {
        await authenticationService.logout();
        history.push("/authentication/login");
    }

    handleMain = () => {
        history.push("/modules/main");
    }

    showNavbar() {
        return (<NavbarBrand href="/">
            {<b className="logo-icon">
                <img
                    src={logolighticon}
                    width="45px"
                    height="20px"
                    alt="homepage"
                    className="light-logo"
                />
            </b>}
            <span className="logo-text">
                <img
                    width="148"
                    height="19"
                    src={logolighttext}
                    className="light-logo"
                    alt="homepage"
                />
            </span>
            {
                utilHelper.isDevelopEnvironment() && <img
                    width="30"
                    height="30"
                    src={developicon}
                    className="light-logo"
                    alt="develop"
                />
            }
        </NavbarBrand>);
    }

    goToMyNotifications () {
        this.setState({loading : true})
        const module = JSON.parse(localStorage.getItem('profileModule'));
        if (module){
            mainService.getAllPermission({module: module});
            mainService.getMenuSideBar({ module : {id : module } }).then(
                menus => {
                    localStorage.setItem('menus', JSON.stringify(menus));
                    localStorage.setItem('module', JSON.stringify(module));
                    this.setState({loading: false, redirect: true});
                }
            ).catch(_ => {
                this.setState({loading: false});
            });
        }else {
            this.setState({loading: false});
        }
    }

    goToNotification (notificationId) {
        this.setState({loading : true})
        toDoTaskService.getItem(notificationId)
            .then(item => {
                const module = JSON.parse(localStorage.getItem('profileModule'));
                if (module){
                    mainService.getMenuSideBar({ module : {id : module } }).then(
                        menus => {
                            localStorage.setItem('menus', JSON.stringify(menus));
                            localStorage.setItem('module', JSON.stringify(module));
                            localStorage.setItem('notificationItem', JSON.stringify(item));
                            this.setState({loading: false, redirect: true});
                            // from server
                            window.location.reload();
                        }
                    );
                }else {
                    this.setState({loading: false});
                }
            });
    }

    render() {
        const { currentEmployee, currentUser, notifications, isTodoTask, redirect } = this.state;
        return (
            <header
                className="topbar navbarbg"
                data-navbarbg={this.props.settings.activeNavbarBg}
            >
                { this.state.loading && showLoader()}
                <Navbar
                    className={
                        'top-navbar ' +
                        (this.props.settings.activeNavbarBg === 'skin6'
                            ? 'navbar-light'
                            : 'navbar-dark')
                    }
                    expand="md"
                >
                    <div
                        className="navbar-header"
                        id="logobg"
                        style={{background: "linear-gradient(268.81deg, #5F73CA -10.85%, #2F438F 0%)"}}
                        //data-logobg={this.props.settings.activeLogoBg}
                    >
                        {/*--------------------------------------------------------------------------------*/}
                        {/* Mobile View Toggler  [visible only after 768px screen]                         */}
                        {/*--------------------------------------------------------------------------------*/}
                        <span
                            className="nav-toggler d-block d-md-none text-white"
                            onClick={this.showMobilemenu}
                        >
							<i className="ti-menu ti-close"/>
						</span>
                        {/*--------------------------------------------------------------------------------*/}
                        {/* Logos Or Icon will be goes here for Light Layout && Dark Layout                */}
                        {/*--------------------------------------------------------------------------------*/}
                        {this.showNavbar()}
                        {/*--------------------------------------------------------------------------------*/}
                        {/* Mobile View Toggler  [visible only after 768px screen]                         */}
                        {/*--------------------------------------------------------------------------------*/}
                        <span
                            className="topbartoggler d-block d-md-none text-white"
                            onClick={this.toggle}
                        >
							<i className="ti-more"/>
						</span>
                    </div>
                    <Collapse
                        className="navbarbg"
                        isOpen={this.state.isOpen}
                        navbar
                        data-navbarbg={this.props.settings.activeNavbarBg}
                    >
                        <Nav className="float-left" navbar>
                            {<NavItem>
                                <NavLink
                                    href="#"
                                    className="d-none d-md-block"
                                    onClick={this.sidebarHandler}
                                >
                                    <i className="ti-menu"/>
                                </NavLink>
                            </NavItem>}
                            {/*--------------------------------------------------------------------------------*/}
                            {/* Start Mega Menu Dropdown                                                       */}
                            {/*--------------------------------------------------------------------------------*/}
                            {<NavItem>
                                <NavLink
                                    href="#"
                                    className="d-none d-md-block"
                                    onClick={this.handleMain}>
                                    <i className="mdi mdi-view-grid"/>
                                </NavLink>
                            </NavItem>}
                            {/*--------------------------------------------------------------------------------*/}
                            {/* End Mega Menu Dropdown                                                         */}
                            {/*--------------------------------------------------------------------------------*/}
                        </Nav>
                        <Nav className="ml-auto float-right" navbar>
                            {/*--------------------------------------------------------------------------------*/}
                            {/* End Notifications Dropdown                                                     */}
                            {/*--------------------------------------------------------------------------------*/}
                            {/*--------------------------------------------------------------------------------*/}
                            {/* End Messages Dropdown                                                          */}
                            {/*--------------------------------------------------------------------------------*/}
                            {/*--------------------------------------------------------------------------------*/}
                            {/* Start Profile Dropdown                                                         */}
                            {/*--------------------------------------------------------------------------------*/}
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret className="pro-pic">
                                    <span>
                                         {
                                             currentUser?.name !== undefined ?
                                                 currentUser?.name
                                                 + " " +
                                                 currentUser?.lastName : ''
                                         }
                                    </span>
                                    <img
                                        src={profilePhotoWhite}
                                        alt="user"
                                        width="30"
                                    />
                                </DropdownToggle>
                                <DropdownMenu right className="user-dd">
                                    <div className="d-flex no-block align-items-center p-3 mb-2 border-bottom">
                                        <div className="">
                                            <img
                                                src={profilePhotoBlue}
                                                alt="user"
                                                className="rounded"
                                                width="60"
                                            />
                                        </div>
                                        <div className="ml-3">
                                            <h4 className="mb-0">  {
                                                currentEmployee?.name
                                                    + " " +
                                                currentEmployee?.lastName
                                            }</h4>
                                            <p className="text-muted mb-0">  {
                                               currentEmployee?.number
                                            }</p>
                                        </div>
                                    </div>
                                    <DropdownItem onClick={this.showModal}>
                                        <i className="fas fa-key mr-1 ml-1"/> Cambiar Contraseña
                                    </DropdownItem>
                                    <DropdownItem onClick={this.handleLogout}>
                                        <i className="fa fa-power-off mr-1 ml-1"/> Salir
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            {/*--------------------------------------------------------------------------------*/}
                            {/* End Profile Dropdown                                                           */}
                            {/*--------------------------------------------------------------------------------*/}
                        </Nav>
                    </Collapse>
                </Navbar>
                {
                    <UserPasswordModal ref={this.childRef}/>
                }
            </header>
        );
    }
}

export default connect(mapStateToProps)(Header);
